import React, { useState } from "react";
import NavBar from "./NavBar";
import { API_IP } from "../global_variables";
import BackgroundImage from "./../images/consultation_background.png";
import { useNavigate } from "react-router-dom";
import { axiosReqConfig } from "../functions/axiosRequest";
import "./Consultation.css";

const BookConsultation = ({ services }) => {
  const [time, setTime] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [city, setCity] = useState("");
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [details, setDetails] = useState("");
  const [isEmailVisible, setIsEmailVisible] = useState(false);
  const [isCallVisible, setIsCallVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isFinished, setIsFinished] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputPhoneNumber = (event) => {
    setPhoneNumber(event.target.value);
  };
  const handleInputEmail = (event) => {
    setEmail(event.target.value);
  };
  const handleClickTime = (val) => {
    setTime(val);
  };

  const handleClickContact = (val) => {
    setContact(val);
    if (val === "Email") {
      setIsEmailVisible(true);
      setIsCallVisible(false);
      setPhoneNumber("");
    } else {
      setIsCallVisible(true);
      setIsEmailVisible(false);
      setEmail("");
    }
  };

  const handleInputCity = (event) => {
    setCity(event.target.value);
  };

  const handleInputName = (event) => {
    setName(event.target.value);
  };

  const handleInputDetails = (event) => {
    setDetails(event.target.value);
  };

  const handleCheckboxServices = (value) => {
    if (selectedServices.includes(value)) {
      setSelectedServices((prev) =>
        prev.filter((service) => service !== value),
      );
    } else {
      setSelectedServices((prev) => [...prev, value]);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      !time ||
      !contact ||
      !city ||
      !name ||
      selectedServices.length === 0 ||
      (contact === "Email" && !email) ||
      (contact !== "Email" && !phoneNumber)
    ) {
      alert("Please fill in all required fields.");
      return;
    }

    setIsFinished(true);
    setIsLoading(true);

    const servicesString = selectedServices.join(", ");

    const formData = {
      time,
      contact,
      city,
      name,
      email,
      phoneNumber,
      details,
      servicesString,
    };

    await axiosReqConfig(`${API_IP}/api/consultation`, "post", formData);
    setIsLoading(false);
  };

  return (
    <div className="BC-container">
      <div
        className="BC-hero"
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <div className="BC-hero-content">
          <h1 className="BC-title">Free Care Consultation</h1>
        </div>
      </div>

      <div className="BC-main-content">
        <div className="BC-info-side">
          <h2>Book a Free In-Home or Virtual Care Consultation</h2>
          <p className="BC-info-subtitle">
            Let’s connect. Our free in-home or virtual care consultations are an
            opportunity for us to get to know you, understand your needs, and
            discuss how iCare Village can support you or your loved one at home.
          </p>
          <p className="BC-info-desc">
            During this consultation, a member of our care team will listen
            carefully, answer your questions, and help identify the most
            appropriate services and next steps. There is no obligation and no
            pressure – we are here to help.
          </p>
          <img
            src={require(`./../images/SeniorCare_1.jpg`)}
            alt="Senior Care"
            className="BC-info-image"
          />
          <button
            className="BC-learn-more-btn"
            onClick={() => navigate("/AboutUs")}
          >
            Learn About Our Care Approach
          </button>
        </div>

        <div className="BC-form-side">
          {!isFinished ? (
            <div className="BC-form-container">
              <div className="BC-form-header">
                <p>
                  Please complete the form below and a member of our iCare
                  Village care team will contact you within 24 hours.
                </p>
              </div>

              <div className="BC-form-body">
                <div className="BC-form-group">
                  <label className="BC-group-label">
                    When do you anticipate needing care support? *
                  </label>
                  <div className="BC-options-grid">
                    {[
                      { label: "Immediately", value: "Immediately" },
                      { label: "Within a week", value: "Within A Week" },
                      { label: "Within 30 days", value: "Within 30 Days" },
                      { label: "Within 3 months", value: "Within 3 Months" },
                      { label: "Not sure yet", value: "Not Sure" },
                    ].map((item, idx) => (
                      <div
                        key={idx}
                        className={`BC-option-card ${time === item.value ? "selected" : ""}`}
                        onClick={() => handleClickTime(item.value)}
                      >
                        <div
                          className={`BC-radio ${time === item.value ? "checked" : ""}`}
                        ></div>
                        <span>{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="BC-form-group">
                  <label className="BC-group-label">
                    Where will care be provided? *
                  </label>
                  <input
                    type="text"
                    className="BC-text-input"
                    placeholder="e.g., Victoria, BC"
                    value={city}
                    onChange={handleInputCity}
                  />
                </div>

                <div className="BC-form-group">
                  <label className="BC-group-label">
                    Which care services are you interested in? *
                  </label>
                  <p className="BC-form-note">
                    You may select more than one option
                  </p>
                  <div className="BC-options-grid">
                    {services &&
                      services.map((service, index) => {
                        const isSelected = selectedServices.includes(
                          service.care_service_name,
                        );
                        return (
                          <div
                            key={index}
                            className={`BC-option-card ${isSelected ? "selected" : ""}`}
                            onClick={() =>
                              handleCheckboxServices(service.care_service_name)
                            }
                          >
                            <div
                              className={`BC-checkbox ${isSelected ? "checked" : ""}`}
                            ></div>
                            <span>{service.care_service_name}</span>
                          </div>
                        );
                      })}
                  </div>
                </div>

                <div className="BC-form-group">
                  <label className="BC-group-label">
                    Please share any details about your needs or questions.
                  </label>
                  <textarea
                    className="BC-text-input"
                    rows="4"
                    value={details}
                    placeholder="Tell us a little about the support you’re looking for..."
                    onChange={handleInputDetails}
                  ></textarea>
                </div>

                <div className="BC-form-group">
                  <label className="BC-group-label">Full Name *</label>
                  <input
                    type="text"
                    className="BC-text-input"
                    value={name}
                    placeholder="Your Full Name"
                    onChange={handleInputName}
                  />
                </div>

                <div className="BC-form-group">
                  <label className="BC-group-label">
                    How would you prefer us to contact you? *
                  </label>
                  <div className="BC-contact-methods">
                    {[
                      { label: "Email", value: "Email" },
                      { label: "Phone Call", value: "Call" },
                      { label: "Text Message", value: "Text Message" },
                    ].map((item, idx) => (
                      <div
                        key={idx}
                        className={`BC-contact-btn ${contact === item.value ? "active" : ""}`}
                        onClick={() => handleClickContact(item.value)}
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="BC-form-group">
                  {!isCallVisible && !isEmailVisible && (
                    <p className="BC-form-note">
                      Please select one preferred contact method above.
                    </p>
                  )}
                  {isCallVisible && (
                    <>
                      <label className="BC-group-label">Phone Number *</label>
                      <input
                        type="tel"
                        className="BC-text-input"
                        value={phoneNumber}
                        placeholder="Enter your phone number"
                        onChange={handleInputPhoneNumber}
                      />
                    </>
                  )}
                  {isEmailVisible && (
                    <>
                      <label className="BC-group-label">Email *</label>
                      <input
                        type="email"
                        className="BC-text-input"
                        value={email}
                        placeholder="Enter your email address"
                        onChange={handleInputEmail}
                      />
                    </>
                  )}
                </div>

                <button className="BC-submit-btn" onClick={handleSubmit}>
                  Submit Request
                </button>
                <p className="BC-footer-note">
                  A member of our iCare Village care team will respond within 24
                  hours.
                </p>
              </div>
            </div>
          ) : (
            <div className="BC-status-container">
              {!isLoading ? (
                <div className="BC-success-card">
                  <h2>Your request has been submitted!</h2>
                  <img
                    src={require(`../images/submit-img.png`)}
                    alt="Success"
                  />
                  <p>We will be in touch with you shortly.</p>
                  <button
                    className="BC-learn-more-btn"
                    onClick={() => navigate("/")}
                    style={{
                      marginTop: "20px",
                      width: "auto",
                      padding: "12px 30px",
                    }}
                  >
                    Return to Home
                  </button>
                </div>
              ) : (
                <div className="BC-loading-card">
                  <h2>Submitting...</h2>
                  <img
                    src={require(`../images/loading_icon.gif`)}
                    alt="Loading"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookConsultation;
